import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseCategoryRoute = 'app/talking-point/category'
const baseCategoryFunctions = GetBaseServiceFunctions(BaseCategoryRoute)
const API = { ...baseCategoryFunctions }
export default API
